module.exports = __webpack_public_path__ + "static/village_bg-a01d787f19f11736b565f4cd7f7f3967.png";